<form [formGroup]="itemForm">
    <mat-form-field style="width:180px;" appearance="fill">
        <mat-label>Inventory ID</mat-label>
        <input matInput #inventoryID scanInput="ITM" formControlName="inventoryID"
            (scanned)="onInventoryIDEntered($event)" autofocus />
        <button mat-icon-button matSuffix type="button" (click)="itemFormReset()">
            <mat-icon>cancel</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field style="width:240px;" appearance="fill">
        <mat-label>Lot/Serial #</mat-label>
        <input matInput #inventoryID scanInput="LOT" formControlName="lotSerialNbr"
            (scanned)="onLotNumberEntered($event)" />
    </mat-form-field>
</form>

<mat-tab-group #tabGroup>
    <mat-tab label="Stock Check">
        <table mat-table #stockCheckRequestsTable [dataSource]="stockCheckRequests" class="stock-checks">
            <ng-container matColumnDef="Completed">
                <th mat-header-cell *matHeaderCellDef>✔</th>
                <td mat-cell *matCellDef="let row"><span *ngIf="row.source?.hasAdjustment">✔</span></td>
            </ng-container>
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let row" (click)="toggleLotDisplay()">
                    {{row.InventoryID}}<br />
                    <div [attr.data-lotHash]="row.LotSerialHash">
                        {{displayLotHashNbrs ? (row.LotSerialHash || row.LotSerialNbr) : row.LotSerialNbr}}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="LocationID">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let row">{{row.LocationID}}</td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Available</th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.source">
                        {{row.source.AdjQtyAvailable | quantityFraction}}<span
                            *ngIf="(row.source.AdjQtyAvailable != row.source.AdjQtyOnHand)"><br />of
                            {{row.source.AdjQtyOnHand | quantityFraction}}</span>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="LotSerialNbr">
                <th mat-header-cell *matHeaderCellDef>Lot #</th>
                <td mat-cell *matCellDef="let row">{{row.LotSerialNbr}}</td>
            </ng-container>
            <ng-container matColumnDef="Menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row"><button mat-icon-button
                        [matMenuTriggerFor]="stockCheckMenu"><mat-icon>more_vert</mat-icon></button>
                    <mat-menu #stockCheckMenu>
                        <button *ngIf="row.source" mat-menu-item (click)="printStockTag(row.source)">
                            <mat-icon>sell</mat-icon>
                            <span>Print Stock Tag</span>
                        </button>
                        <button mat-menu-item
                            (click)="openRequestInfoDialog(row)"><mat-icon>contact_support</mat-icon>Request
                            Info</button>
                        <button mat-menu-item (click)="transferToLost(row)"><mat-icon>eject</mat-icon>Move to
                            Lost</button>
                        <button mat-menu-item (click)="zeroOutPiece(row)"><mat-icon>hide_source</mat-icon>Adjust
                            Out</button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="stockCheckColumns"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: stockCheckColumns"></tr>
        </table>
    </mat-tab>

    <mat-tab label="Bin Audit" *ngIf="binAuditRequests.length > 0">
        <table mat-table #binAuditTable [dataSource]="binAuditRequests" class="stock-checks">
            <ng-container matColumnDef="Completed">
                <th mat-header-cell *matHeaderCellDef>✔</th>
                <td mat-cell *matCellDef="let row"><span *ngIf="row.source?.hasAdjustment">✔</span></td>
            </ng-container>
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let row">{{row.InventoryID}}<br />{{row.LotSerialNbr}}</td>
            </ng-container>
            <ng-container matColumnDef="LocationID">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let row">{{row.LocationID}}</td>
            </ng-container>
            <ng-container matColumnDef="QtyAvailable">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let row">{{row.source?.QtyAvailable}}</td>
            </ng-container>
            <ng-container matColumnDef="Menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="stockCheckMenu"><mat-icon>more_vert</mat-icon></button>
                    <mat-menu #stockCheckMenu>
                        <button *ngIf="row.source" mat-menu-item (click)="printStockTag(row.source)">
                            <mat-icon>sell</mat-icon>
                            <span>Print Stock Tag</span>
                        </button>
                        <button mat-menu-item (click)="zeroOutPiece(row)"><mat-icon>hide_source</mat-icon>Adjust
                            Out</button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="stockCheckColumns"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: stockCheckColumns"></tr>
        </table>
    </mat-tab>

    <mat-tab label="Adjustments">
        <table mat-table #adjustmentsTable [dataSource]="modifiedInventory" class="adjustments-table">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let row" (click)="toggleLotDisplay()">{{row.InventoryID}}<div>
                        {{displayLotHashNbrs ? (row.LotSerialHash ||
                        row.LotSerialNbr) : row.LotSerialNbr}}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="LocationID">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="row.isTransfer">
                        {{row.OriginalLocationID}} ▶</div>
                    {{row.LocationID}}
                </td>
            </ng-container>
            <ng-container matColumnDef="OnHand">
                <th mat-header-cell *matHeaderCellDef>On Hand</th>
                <td mat-cell *matCellDef="let row">{{row.AdjustmentQty | signed}}<div>
                        {{row.AdjQtyOnHand}} {{row.stockItem.BaseUOM}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row"><button mat-icon-button
                        [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button *ngIf="row.source" mat-menu-item (click)="printStockTag(row.source)">
                            <mat-icon>sell</mat-icon>
                            <span>Print Stock Tag</span>
                        </button>
                        <button mat-menu-item (click)="editInventorySource(row)">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item *ngIf="row.isTransfer" (click)="cancelTransfer(row)">
                            <mat-icon>trending_up</mat-icon>
                            <span>Cancel Transfer</span>
                        </button>
                        <button mat-menu-item *ngIf="row.hasAdjustment" (click)="cancelAdjustment(row)">
                            <mat-icon>undo</mat-icon>
                            <span>Cancel Adjustment</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="inventoryColumns"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: inventoryColumns"></tr>
        </table>
    </mat-tab>

    <mat-tab label="Restock" *ngIf="inventoryInHoldForRestock.length">
        <table mat-table #restockTable [dataSource]="inventoryInHoldForRestock">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Inventory ID</th>
                <td mat-cell *matCellDef="let row" (click)="toggleLotDisplay()">{{row.InventoryID}}<div>
                        {{displayLotHashNbrs ? (row.LotSerialHash ||
                        row.LotSerialNbr) : row.LotSerialNbr}}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef>Available</th>
                <td mat-cell *matCellDef="let row">
                    {{row.AdjQtyAvailable | quantityFraction}}<span *ngIf="(row.AdjQtyAvailable != row.AdjQtyOnHand)">
                        of
                        {{row.AdjQtyOnHand | quantityFraction}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="restockHoldColumns"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: restockHoldColumns"></tr>
        </table>
    </mat-tab>
</mat-tab-group>

<ng-template #inventoryDataLoading>
    <mat-spinner diameter="30" style="display: inline-block;"></mat-spinner> Item &amp; Inventory loading...
</ng-template>

<ng-template #stockChecksLoading>
    <mat-spinner diameter="25" style="display:inline-block; margin: 0 0.5em;">
    </mat-spinner>Getting Stock Check Requests...
</ng-template>

<ng-template #getBinLocation>
    <warehouse-location-selector #getBinLocationSelector [validLocations]="warehouseLocations"
        (onLocationIDEntered)="onBinAuditLocationEntered($event)"></warehouse-location-selector>

    <mat-checkbox [(ngModel)]="BinAuditRollout" (click)="onBinAuditRollout()">Roll-Out / Measure</mat-checkbox>

    <mat-dialog-actions>
        <button mat-raised-button color="primary" [mat-dialog-close]="null">Cancel</button>
    </mat-dialog-actions>
</ng-template>

<ng-template let-request #stockCheckRequestInfoDialog>
    <div (click)="closeRequestInfoDialog()">
        <div style="text-align:center;">
            <div style="width:260px; height:260px; border: thin dashed #ccc; margin-bottom: 0.5em; display:block;"
                *ngIf="_stockItems[request.InventoryID] | async as item">
                <img *ngIf="item" [src]="item.ProductImageURL(90, 260)">
            </div>
        </div>
        <div>{{request.Requestor}}</div>
        <div>{{request.RequestDate | date:'shortDate'}}, {{request.RequestDate | date:'shortTime'}}</div>
    </div>
</ng-template>

<ng-template #selectLocationForLotSerNbrDialogTemplate let-data>
    <h3>Lot # exists in multiple Locations - Confirm Source</h3>
    <div *ngFor="let piece of data.inventory" style="text-align:center;">
        <button mat-raised-button style="margin:0.2em;" color="accent" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{piece.BaseUOM}} in {{piece.LocationID}}
        </button>
    </div>
</ng-template>